import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './printlogs.action';

@Injectable({ providedIn: 'root' })
export class PrintlogsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    statuses = [
        {id: "1", name:"SENT_CORRESPONDENCE.queued"},
        {id: "2", name:"SENT_CORRESPONDENCE.sent"},
        {id: "3", name:"SENT_CORRESPONDENCE.failed"},
        {id: "4", name:"SENT_CORRESPONDENCE.failed-permanently"}
    ];
    filters = {
                id: '',
                created_at: '',
                member_name: '', 
                contact_info: '', 
                template_title: '',
                status_text: null
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    associations = [];
    columns = [
                { prop: 'id', name: 'PRINTLOG.letter-id', sortable: true, hasFilter: true, filter: "input", widthSet: 180},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'member_name', name: 'PRINTLOG.receiver-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'contact_info', name: 'PRINTLOG.receiver-address', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'template_title', name: 'PRINTLOG.template-title', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'status_text', name: 'PRINTLOG.sent-status', sortable: false, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name", widthSet: 200},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            id: '',
            created_at: '',
            member_name: '', 
            contact_info: '', 
            template_title: '',
            status_text: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}